"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsoQueryField = void 0;
var SsoQueryField;
(function (SsoQueryField) {
    SsoQueryField["ERROR"] = "sso_error";
    SsoQueryField["TOKEN"] = "firebase_custom_token";
    SsoQueryField["SSO_PROVIDER"] = "sso_provider";
})(SsoQueryField || (exports.SsoQueryField = SsoQueryField = {}));
